/**
 * Get unread messages from mnemonics reducer
 * @param {object} mnemonics
 * @param {object} payload
 * @param {string} payload.location
 * @param {string} payload.userId
 * @param {number} payload.currentUnreadMsg
 *
 * @returns {number}
 */
export function getUnreadMessages(mnemonics, payload) {
  const { location, userId, currentUnreadMsg } = payload

  if (location === 'poolMain') return mnemonics.totalMainPool || 0
  if (location === 'poolAssigned') return mnemonics.totalAssigned || 0
  if (location === 'poolLists') return currentUnreadMsg || 0

  if (!mnemonics.users[userId]) return currentUnreadMsg || 0
  const unreadMsg = mnemonics.users[userId].pendingMsgCount || 0

  return currentUnreadMsg > unreadMsg ? currentUnreadMsg : unreadMsg
}

/**
 * Get badge color class
 * @param {number} numMsg
 *
 * @returns {string}
 */
export function getBadgeColorClass(numMsg) {
  if (numMsg === 1) return 'success'
  if (numMsg === 2) return 'warning'
  if (numMsg === 3) return 'danger'

  return 'danger blinking'
}

/**
 * Get class name for badge container
 * @param {object} payload
 * @param {string} payload.location
 * @param {boolean} payload.isSidebar
 *
 * @returns {string}
 */
export function getBadgeContainerClassname(payload) {
  const { location, isSidebar } = payload

  if (isSidebar) return 'side-bar'
  if (location === 'poolMain') return 'side-menu'
  if (location === 'poolAssigned') return 'side-menu'
  if (location === 'search') return 'search'
  if (location === 'poolLists') return 'side-menu'
  if (location === 'userCard') return 'side-menu-user-card'

  return 'unread-messages'
}

/**
 * Get label for tooltip
 * @param {object} payload
 * @param {string} payload.location
 * @param {boolean} payload.showTooltip
 *
 * @returns {string}
 */
export function getTooltip(payload) {
  const { location, showTooltip } = payload

  if (!showTooltip) return ''
  if (location === 'poolMain') return 'sidemenu_mnemonics_main_tooltip'
  if (location === 'poolAssigned') return 'sidemenu_mnemonics_assigned_tooltip'

  return ''
}
